export default "__VITE_ASSET__BD12qxh3__"